window.$ = window.jQuery = require('jquery');

import '../js/modules/header';
import '../js/modules/dropdown';
import '../js/slider';
import '../js/copy';
